import { CurrentProviderContext } from '../../../Components/Permissions';
import { Permission } from '../../../graphQL';
import { UserType } from '../types';
import { AppointmentsTab } from './Appointments';
import { AssessmentsTab } from './Assessments';
import { BeaconTab } from './Beacon';
import { CareTeamTab } from './CareTeam';
import { FilesTab } from './Files';
import { MessagesTab } from './Messages';
import { NotesTab } from './Notes';
import { OutreachTab } from './Outreach';
import { OverviewTab } from './Overview';
import { SafetyPlanTab } from './SafetyPlan';
import { SecurityTab } from './Security';

const keys = [
  'overview',
  'messages',
  'beacon',
  'notes',
  'assessments',
  'files',
  'appointments',
  'provider-messages',
  'safety-plan',
  'outreach',
  'security',
] as const;

type Tab = {
  key: typeof keys[number];
  text: string;
  component: () => JSX.Element;
  condition: (arg0: CurrentProviderContext, arg1: UserType) => boolean;
};

export const DrilldownTabs: Tab[] = [
  {
    key: 'overview',
    text: 'Overview',
    component: OverviewTab,
    condition: () => true,
  },
  {
    key: 'messages',
    text: 'Messages',
    component: MessagesTab,
    condition: ({ hasPermission }) => hasPermission(Permission.PatientMessage),
  },
  {
    key: 'beacon',
    text: 'Beacon',
    component: BeaconTab,
    condition: ({ hasPermission }) =>
      hasPermission(Permission.SaiDataViewStudentDetailsAnyorg) ||
      hasPermission(Permission.SaiDataViewStudentDetailsOwnorg),
  },
  {
    key: 'notes',
    text: 'Notes',
    component: NotesTab,
    condition: ({ hasPermission }) => hasPermission(Permission.Phi),
  },
  {
    key: 'assessments',
    text: 'Assessments',
    component: AssessmentsTab,
    condition: ({ hasPermission }) => hasPermission(Permission.Phi),
  },
  {
    key: 'files',
    text: 'Files',
    component: FilesTab,
    condition: () => true,
  },
  {
    key: 'appointments',
    text: 'Appointments',
    component: AppointmentsTab,
    condition: () => true,
  },
  {
    key: 'safety-plan',
    text: 'Safety',
    component: SafetyPlanTab,
    condition: ({ hasPermission }) => hasPermission(Permission.Phi),
  },
  {
    key: 'provider-messages',
    text: 'Collaboration Team',
    component: CareTeamTab,
    condition: ({ hasPermission }, { organization }) =>
      hasPermission(Permission.ProviderMessage) && !!organization,
  },
  {
    key: 'outreach',
    text: 'Outreach',
    component: OutreachTab,
    condition: () => true,
  },
  {
    key: 'security',
    text: 'Security',
    component: SecurityTab,
    condition: context => showSecurityTab(context),
  },
];

// Only show Security tab to users with the right permission and have 2FA enabled
const showSecurityTab = (context: CurrentProviderContext) => {
  const {
    hasPermission,
    currentProvider: { twoFactorConfig },
  } = context;
  if (!twoFactorConfig) return false;
  return hasPermission(Permission.GeneratePassword) && twoFactorConfig.enabled;
};
